import HeadingGroup from './HeadingGroup';

export type { HeadingGroupProps } from './HeadingGroup';
export default HeadingGroup;
